import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Layout, Button, Modal } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { ImageUrl } from "../../helpers/Functions";
import "./b2b-training.css";

function Homepage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const videoRef = useRef(null);
  const [modal2Open, setModal2Open] = useState(false);

  React.useEffect(() => {
    if (!user && !token) {
      navigate("/", { replace: true });
    }
  }, [user, token, navigate]);

  useEffect(() => {
    if (modal2Open && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Autoplay failed:", error);
      });
    }
  }, [modal2Open]);

  const data2 = [
    { title: "Provide course access to users directly after purchase." },
  ];

  const data3 = [
    { title: "Customers can access a courses directly after payment." },
    { title: "Skip eCommerce and manually enroll users into courses." },
  ];

  const data4 = [
    {
      title: "Create a course catalog, ‘about us’, checkout page, and more.",
    },
    {
      title:
        "Change website menus & pages, and customize your eCommerce store to best represent your company.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Janitorial Supplies & Green Cleaning Products for Childcare
        </title>
        <meta
          property="og:title"
          content="Janitorial Supplies & Green Cleaning Products for Childcare"
        />
      </Helmet>

      <Layout className="b2b-page">
        <section
          className="b2b-hero"
          style={{ backgroundImage: `url(${ImageUrl("new-22.png")})` }}
        >
          <div className="b2b-hero-overlay" aria-hidden />
          <div className="b2b-wrap b2b-hero-inner">
            <div className="b2b-hero-copy">
              <span className="b2b-hero-badge">FLEXIBLE ECOMMERCE</span>
              <h1 className="fontFamily1 b2b-hero-title">
                Sell Your Courses & <span>eLearning Online</span>
              </h1>
              <p className="fontFamily1 b2b-hero-sub">
                Earn revenue from your courses and programs, by selling them
                online with our customizable landing pages, or by connecting
                them to your own eCommerce site.
              </p>
              <div className="b2b-hero-actions">
                {!token && (
                  <Button
                    type="primary"
                    className="b2b-hero-btn-primary"
                    onClick={() => navigate("/signup")}
                  >
                    Register Now
                  </Button>
                )}
                <Button
                  className="b2b-hero-btn-outline"
                  onClick={() => setModal2Open(true)}
                >
                  See The Platform <FaArrowRight />
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--white">
          <div className="b2b-wrap">
            <div className="b2b-split">
              <div className="b2b-split-media">
                <img src={ImageUrl("new-16.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-split-copy">
                <img
                  src={ImageUrl("miniImg.png")}
                  alt=""
                  className="b2b-section-kicker"
                />
                <h2 className="fontFamily1">
                  Sell Courses Directly On Your Platform Or Connect To An
                  Existing Store
                </h2>
                <p>
                  Offer your courses for sale using a storefront created with
                  WrightCo Academy. If you already have an eCommerce site, sell
                  your courses there.
                </p>
                <ul className="b2b-check-list">
                  {data4.map((item) => (
                    <li key={item.title}>
                      <FaCheckCircle aria-hidden />
                      <span>{item.title}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  className="b2b-btn-ghost"
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--muted">
          <div className="b2b-wrap">
            <div className="b2b-section-intro">
              <span className="b2b-section-kicker">
                <img src={ImageUrl("miniImg4.png")} alt="" />
              </span>
              <h2 className="fontFamily1 b2b-section-title">
                Customize The Shopping Experience{" "}
                <span style={{ color: "#00b8ae" }}>For Your Learners</span>
              </h2>
              <p className="fontFamily1 b2b-section-lead">
                Ensure your customers have a great experience purchasing
                courses, by customizing your website with different colors,
                menus, pages, and more.
              </p>
            </div>

            <div className="b2b-cards">
              <article className="b2b-card">
                <div className="b2b-card-media">
                  <img src={ImageUrl("new-23.png")} alt="" loading="lazy" />
                </div>
                <div className="b2b-card-body">
                  <h3>Categorize Courses by Training Type</h3>
                  <p>
                    Categorize your courses to help customers find training
                    courses by sector, job role, and more.
                  </p>
                </div>
              </article>
              <article className="b2b-card">
                <div className="b2b-card-media">
                  <img src={ImageUrl("new-24.png")} alt="" loading="lazy" />
                </div>
                <div className="b2b-card-body">
                  <h3>Visually Brand Your Website</h3>
                  <p>
                    When selling courses directly on our software, you can use
                    your logo and brand colors throughout the site.
                  </p>
                </div>
              </article>
              <article className="b2b-card">
                <div className="b2b-card-media">
                  <img src={ImageUrl("new-25.png")} alt="" loading="lazy" />
                </div>
                <div className="b2b-card-body">
                  <h3>Create Unique Pages & Menus</h3>
                  <p>
                    Customize your eLearning sites’ landing pages, navigation
                    menus, and more with our site-builder.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--navy">
          <div className="b2b-wrap">
            <div className="b2b-section-intro">
              <span className="b2b-section-kicker">
                <img src={ImageUrl("miniImg2.png")} alt="" />
              </span>
              <h2 className="fontFamily1 b2b-section-title">
                Connect With Payment Gateways
              </h2>
              <p className="fontFamily1 b2b-section-lead">
                Connect with Stripe, Authorize.net, and Braintree by PayPal to
                accept course payments. Bank-grade SSL security certificates make
                sure that your customers’ data is fully encrypted.
              </p>
              {!token && (
                <div className="b2b-cta-center">
                  <Button
                    className="b2b-btn-light"
                    onClick={() => navigate("/signup")}
                  >
                    Get Started
                  </Button>
                </div>
              )}
            </div>
            <div
              className="b2b-split-media"
              style={{ maxWidth: 980, margin: "0 auto" }}
            >
              <img src={ImageUrl("new-26.png")} alt="" loading="lazy" />
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--white">
          <div className="b2b-wrap">
            <div className="b2b-split">
              <div className="b2b-split-copy">
                <img
                  src={ImageUrl("miniImg4.png")}
                  alt=""
                  className="b2b-section-kicker"
                />
                <h2 className="fontFamily1">
                  Help Customers Find Training & Purchase Courses
                </h2>
                <p>
                  Use different pages, descriptions, and categories to help
                  customers find the right training for them. Use an About Us
                  page to showcase your company, Course Catalog for advertising
                  courses, and then a Check Out page to sell.
                </p>
                <ul className="b2b-check-list">
                  {data3.map((item) => (
                    <li key={item.title}>
                      <FaCheckCircle aria-hidden />
                      <span>{item.title}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  className="b2b-btn-ghost"
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
              <div className="b2b-split-media">
                <img src={ImageUrl("new-27.png")} alt="" loading="lazy" />
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--muted">
          <div className="b2b-wrap">
            <div className="b2b-split">
              <div className="b2b-split-media">
                <img src={ImageUrl("new-28.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-split-copy">
                <img
                  src={ImageUrl("miniImg4.png")}
                  alt=""
                  className="b2b-section-kicker"
                />
                <h2 className="fontFamily1">
                  Sell Courses In Bulk—To Other Teams & Customer Groups
                </h2>
                <p>
                  Sell courses in bulk to other organizations. Purchasers can
                  select the quantity of users they will be training at the
                  checkout page, to purchase training in bulk for their teams or
                  a group of customers.
                </p>
                <ul className="b2b-check-list">
                  {data2.map((item) => (
                    <li key={item.title}>
                      <FaCheckCircle aria-hidden />
                      <span>{item.title}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  className="b2b-btn-ghost"
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--navy">
          <div className="b2b-wrap">
            <div className="b2b-section-intro">
              <span className="b2b-section-kicker">
                <img src={ImageUrl("miniImg2.png")} alt="" />
              </span>
              <h2 className="fontFamily1 b2b-section-title">
                Discount eLearning with Coupons and Sales
              </h2>
              <p className="fontFamily1 b2b-section-lead">
                Discount your courses with coupon codes and put your courses on
                sale temporarily.
              </p>
              {!token && (
                <div className="b2b-cta-center">
                  <Button
                    className="b2b-btn-light"
                    onClick={() => navigate("/signup")}
                  >
                    Get Started
                  </Button>
                </div>
              )}
            </div>
            <div
              className="b2b-split-media"
              style={{ maxWidth: 980, margin: "0 auto" }}
            >
              <img src={ImageUrl("new-29.png")} alt="" loading="lazy" />
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--muted">
          <div className="b2b-wrap">
            <div className="b2b-split">
              <div className="b2b-split-copy">
                <img
                  src={ImageUrl("miniImg.png")}
                  alt=""
                  className="b2b-section-kicker"
                />
                <h2 className="fontFamily1">
                  Offer Flexible Options For Purchasing Courses
                </h2>
                <p>
                  Sell courses with a one-time payment or subscription plan,
                  offer free trials, and bundle related courses together.
                </p>
                <Button
                  className="b2b-btn-ghost"
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
              <div className="b2b-split-media">
                <img src={ImageUrl("new-30.png")} alt="" loading="lazy" />
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-trainer">
          <div className="b2b-wrap">
            <div className="b2b-trainer-card">
              <h3>We&apos;re Looking for Trainers</h3>
              <h3>Teach. Create. Earn.</h3>
              <p>
                Are you passionate about teaching? Ready to share your expertise,
                connect with professionals, and make a meaningful impact, all
                while earning extra income?
              </p>

              <h4>You&apos;ve come to the right place.</h4>
              <p>
                At WrightCo Academy, we are building a network of world-class
                trainers and industry experts dedicated to developing
                high-quality courseware for professionals in early care and
                education. If you&apos;re an expert in your field with a desire
                to teach, we&apos;d love to have you on board!
              </p>

              <h3>Why Join Us?</h3>
              <ul>
                <li>
                  <p>
                    ✅ Expand Your Reach – Share your knowledge with a broad
                    audience of professionals.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Boost Your Visibility – Gain recognition as a trusted
                    expert in your industry.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Join a Thriving Community – Connect with like-minded
                    trainers and industry leaders.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Earn Passive Income – Our fair and flexible revenue-sharing
                    model ensures unlimited earning potential.
                  </p>
                </li>
              </ul>

              <h3>What It Takes to Be a WrightCo Trainer</h3>
              <ul>
                <li>
                  <p>
                    ✔ <strong>Passion for Teaching</strong> – A commitment to
                    sharing knowledge and empowering others.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Industry Expertise</strong> – Relevant
                    certifications and experience in your domain.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Strong Communication Skills</strong> – Ability to
                    present information effectively.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Commitment to Excellence</strong> – Willingness to
                    develop and deliver high-quality training.
                  </p>
                </li>
              </ul>
              <h4>Ready to Make an Impact?</h4>
              <p>
                Join WrightCo Academy today and take the next step in your
                teaching journey.
              </p>
            </div>
          </div>
        </section>

        <Modal
          className="b2b-video-modal"
          centered
          open={modal2Open}
          onOk={() => setModal2Open(false)}
          onCancel={() => setModal2Open(false)}
          width={1000}
          footer={false}
        >
          <div style={{ padding: "24px 12px" }}>
            <video width="auto" height="auto" ref={videoRef} controls>
              <source src="https://react.customdev.solutions:3012/Uploads/tutorVideo.mp4" />
              <source src="movie.ogg" type="video/ogg" />
            </video>
          </div>
        </Modal>
      </Layout>
    </>
  );
}

export default Homepage;
